import { MILLISECONDS_PER_DAY } from '@kwenta/sdk/constants'

// Shows or hides the home page banner entirely when set to true/false
export const BANNER_ENABLED = false
// Sets the link destination for the banner component, or renders the banner as
// plain, un-clickable text if set to a falsey value (`false`, `null`, '', etc...)
export const BANNER_LINK_URL =
	'https://vote.kwenta.eth.limo/#/proposal/0xfe46e7217d85f4375873f8f1ae6fcc029fb27df2ce468d2d08ee0c4b49c62f02'
// Sets the text displayed on the home page banner
export const BANNER_TEXT =
	'Kwenta Council Elections are live! All $KWENTA stakers are invited to vote! ↗'
// Sets the height of the banner component on desktop
export const BANNER_HEIGHT_DESKTOP = 40
// Sets the height of the banner component on mobile
export const BANNER_HEIGHT_MOBILE = 50
// Sets the waiting time of the banner component before it is reactive
export const BANNER_WAITING_TIME = 2 * MILLISECONDS_PER_DAY
